import apiClient from './api';

const FORECAST_LIMIT_MAX = 100;
const FORECAST_LIMIT_DEFAULT = 50;

const clampForecastLimit = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n)) return FORECAST_LIMIT_DEFAULT;
    return Math.min(FORECAST_LIMIT_MAX, Math.max(1, Math.floor(n)));
};

const clampForecastSkip = (value) => {
    const n = Number(value);
    if (!Number.isFinite(n) || n < 0) return 0;
    return Math.floor(n);
};

const buildDashboardParams = (filters = {}) => {
    const params = {};

    if (filters.run_date) params.run_date = filters.run_date;
    if (filters.policy_code?.trim()) params.policy_code = filters.policy_code.trim();
    if (filters.partner_id?.trim()) params.partner_id = filters.partner_id.trim();
    if (filters.company_name?.trim()) params.company_name = filters.company_name.trim();
    if (filters.distribution_type?.trim()) params.distribution_type = filters.distribution_type.trim();
    if (filters.include_completed === false) params.include_completed = 'false';
    if (filters.forecast_timing_hour !== null && filters.forecast_timing_hour !== undefined && filters.forecast_timing_hour !== '') {
        params.forecast_timing_hour = String(filters.forecast_timing_hour);
    }
    if (filters.match_current_hour) params.match_current_hour = 'true';
    if (filters.scope && filters.scope !== 'all') params.scope = filters.scope;
    if (filters.observation_timing_hour !== null && filters.observation_timing_hour !== undefined && filters.observation_timing_hour !== '') {
        params.observation_timing_hour = String(filters.observation_timing_hour);
    }
    if (filters.activity_name?.trim()) params.activity_name = filters.activity_name.trim();
    if (filters.reservation_number?.trim()) params.reservation_number = filters.reservation_number.trim();

    // Pagination items — /forecast
    if (filters.skip !== null && filters.skip !== undefined && filters.skip !== '') {
        params.skip = String(clampForecastSkip(filters.skip));
    }
    if (filters.limit !== null && filters.limit !== undefined && filters.limit !== '') {
        params.limit = String(clampForecastLimit(filters.limit));
    }

    // Pagination forecast — pertinente pour /today
    if (filters.forecast_skip !== null && filters.forecast_skip !== undefined && filters.forecast_skip !== '') {
        params.forecast_skip = String(clampForecastSkip(filters.forecast_skip));
    }
    if (filters.forecast_limit !== null && filters.forecast_limit !== undefined && filters.forecast_limit !== '') {
        params.forecast_limit = String(clampForecastLimit(filters.forecast_limit));
    }

    return params;
};

const buildEndOfStayParams = (filters = {}) => {
    const params = {};

    if (filters.scope && filters.scope !== 'all') params.scope = filters.scope;
    if (filters.trip_end_date_from) params.trip_end_date_from = filters.trip_end_date_from;
    if (filters.trip_end_date_to) params.trip_end_date_to = filters.trip_end_date_to;
    if (filters.policy_code?.trim()) params.policy_code = filters.policy_code.trim();
    if (filters.partner_id?.trim()) params.partner_id = filters.partner_id.trim();
    if (filters.company_name?.trim()) params.company_name = filters.company_name.trim();

    return params;
};

const getDashboard = async (path, filters = {}) => {
    const response = await apiClient.get(`api/dashboard/operations/${path}`, {
        params: buildDashboardParams(filters),
    });
    return response.data;
};

export const fetchTodayDashboard = (filters = {}) => getDashboard('today', filters);

export const fetchForecastDashboard = (filters = {}) => getDashboard('forecast', filters);

export const fetchObservationDashboard = (filters = {}) => getDashboard('observation', filters);

export const fetchEndOfStayDashboard = async (filters = {}) => {
    const response = await apiClient.get('api/dashboard/operations/end-of-stay', {
        params: buildEndOfStayParams(filters),
    });
    return response.data;
};

export { FORECAST_LIMIT_MAX, FORECAST_LIMIT_DEFAULT, clampForecastLimit, clampForecastSkip };
